// Tekster for Oversikt «Fokus» (oktober 2026). Selve Oversikten skriver
// norsk direkte; dette er de få nøklene som går via translate (innstillinger
// og brukermenyen).
export const englishOversiktFokusMessages = {
  crm: {
    settings: {
      sections: { dashboard: "Dashboard" },
      dashboard: {
        help: "Which view «Gjør nå» starts in. Each user can choose, and the choice is remembered; this applies until they have chosen.",
        admin_default: "Administrator",
        member_default: "Employee",
        planned_week: "Planned week (hours)",
      },
    },
    dashboard: {
      old_layout: "Old dashboard",
      new_layout: "New dashboard",
    },
  },
};

export const norwegianOversiktFokusMessages = {
  crm: {
    settings: {
      sections: { dashboard: "Oversikt" },
      dashboard: {
        help: "Hvilken visning «Gjør nå» starter i. Hver bruker kan velge selv, og valget huskes; dette gjelder til de har valgt.",
        admin_default: "Administrator",
        member_default: "Medarbeider",
        planned_week: "Planlagt uke (timer)",
      },
    },
    dashboard: {
      old_layout: "Gammel oversikt",
      new_layout: "Ny oversikt",
    },
  },
};
